import SocialReOptModal from 'components/GlobalModals/SocialReOptModal/SocialReOptModal';
import withGlobalModals from 'hocs/withGlobalModals';

const ConnectedSocialReOptModal = withGlobalModals(SocialReOptModal);

export default ConnectedSocialReOptModal;
